// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PrivacyPolicy/PrivacyPolicy.css
// module id = 1749
// module chunks = 0